export default "__VITE_ASSET__BTZ1NLcX__"